import { useEffect, useState } from "react";
import apiClient from "../client/ApiGetClient";
import { apiConfig } from "../authConfig";
import { useMsal } from "@azure/msal-react";

export function usePostData<T, R>(
  url: string,
  method: string,
  requestBody?: Object | FormData | string
) {
  const [isProgress, setProgress] = useState(false);
  const [errorMsg, setErrorMsg] = useState<Error | null>(null);
  const { instance, accounts } = useMsal();

  const postDataById = async (formData: R): Promise<T | null> => {
    try {
      setProgress(true);

      const data = await apiClient.sendRequest(
        url,
        method,
        formData as FormData
      );


      return data as T;
    } catch (error: any) {
      setErrorMsg(error.message);
      return null;
    } finally {
      setProgress(false);
    }
  };

  return { isProgress, errorMsg, postDataById };
}

export default usePostData;
